// 判断采集的类型，用于埋点上报
export const ContentType = {
  aigc: "aigc采集", //aigc 采集
  material: "素材采集", // 素材
  gather: "普通采集", // 普通采集
};
interface Extra {
  material_id?: string;
  aigc?: number;
}
export const getContentType = (extra: Extra | null) => {
  if (extra?.material_id) {
    return ContentType.material;
  } else if (extra?.aigc === 1) {
    return ContentType.aigc;
  } else {
    return ContentType.gather;
  }
};
